import DirectusCombobox from "../combobox";
import FilterWrapper from "components/filter/wrapper";
import React from "react";
import client from "directus/src/client";

export default function JobCombobox({
  filter,
  hideLabel,
  className = " min-w-[280px] w-full",
  ...props
}) {
  if (hideLabel) {
    return (
      <div className={className}>
        <DirectusCombobox
          client={client}
          collection="jobs"
          fields={["id", "name"]}
          searchKeys={["name"]}
          filter={filter}
          placeholder="Select Job"
          {...props}
        />
      </div>
    );
  }
  return (
    <FilterWrapper label="Job" className={className}>
      <DirectusCombobox
        client={client}
        collection="jobs"
        fields={["id", "name"]}
        searchKeys={["name"]}
        filter={filter}
        {...props}
      />
    </FilterWrapper>
  );
}
